import { IEstado } from "../../../../Interfaces/Geral/Endereco/Estado/EstadoInterfaces";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function ListarEstadosService() {
    return Service(Axios.get<Array<IEstado>>(`/home/estados/listarestados`));
}

export async function ListarEstadoPorIdService(idEstado: number) {
    return Service(Axios.get<IEstado>(`/home/estados/listarestadoporid?idEstado=${idEstado}`));
}

